<template>
  <footer class="site-footer">

    <div class="footer-links">
      <div class="content-max-width md:flex md:flex-between">

        <div class="left">
          <h4
            class="h2"
            v-html="nav.lead_copy"
          >
          </h4>
          <p class="loc-label" v-if="nav.phone">New Zealand</p>
          <a :href="`tel:${nav.phone}`" class="h3" v-if="nav.phone">
            {{nav.phone}}
          </a>
          <p class="loc-label au" v-if="nav.phone_au">Australia</p>
          <a :href="`tel:${nav.phone_au}`" class="h3" v-if="nav.phone_au">
            {{nav.phone_au}}
          </a>
          <div class="flex new-socials">
            <a v-if="nav.linkedin" :href="nav.linkedin" target="_blank"><img src="/images/linkedin-ico.svg" alt="Host Service Linkedin"></a>
            <a v-if="nav.facebook" :href="nav.facebook" target="_blank"><img src="/images/facebook.svg" alt="Host Service Facebook"></a>
          </div>
          <!-- <a href="#" class="scrolltop">
            <img src="/images/tile-arrow-up.png" alt="Host Service scroll to top">
          </a> -->
        </div>

        <div class="links">

          <ul>
            <li>{{nav.col_title_1}}</li>
            <li
              v-for="(link, index) in nav.col_nav_1"
              :key="index"
            >
              <a :href="link.url">{{link.title}}</a>
            </li>
          </ul>

          <ul>
            <li>{{nav.col_title_2}}</li>
            <li
              v-for="(link, index) in nav.col_nav_2"
              :key="index"
            >
              <a :href="link.url">{{link.title}}</a>
            </li>
          </ul>

          <ul>
            <li>{{nav.col_title_3}}</li>
            <li
              v-for="(link, index) in nav.col_nav_3"
              :key="index"
            >
              <a :href="link.url">{{link.title}}</a>
            </li>
          </ul>

        </div>

      </div>
    </div>

    <div class="footer-legal">
      <div class="content-max-width flex">

        <p class="copyright">&copy; Copyright 2023 Hostservice commercial</p>
        <a
          href="https://fromhere.nz/"
          target="_blank"
          class="attribution"
        >
          Website From Here
        </a>

      </div>
    </div>

  </footer>
</template>

<script>
export default {
    props: [
      'nav'
	]
}
</script>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/Footer.vue